export function BeeMark({ className = "h-10 w-10" }) {
    return (
        <img
            src="/busy-bee-mascot.png"
            alt=""
            aria-hidden="true"
            draggable={false}
            className={`${className} object-contain`}
        />
    );
}

export default function Logo({ light = false, testId = "official-logo" }) {
    return (
        <span className={`inline-flex items-center ${light ? "rounded-md bg-white p-1" : ""}`}>
            <img
                src="/busy-bees-official-logo-transparent.png"
                alt="Busy Bees Early Learning Academy Pvt Ltd"
                data-testid={testId}
                className="h-auto w-[150px] object-contain sm:w-[190px]"
            />
        </span>
    );
}
